import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import aboutImage from "../../assets/newGalleryPics/receptionAreaResized.jpg";
import "./AboutUsPage.css";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import {whatsAppBotListener } from "../../utils/Utils";
import { PHONE_NUMBER } from "../../utils/Constant";
import clinicIcon from '../../assets/ivory/DenviaLogo.png';

const coreValues = [
  {
    title: "Patient-Centered Care",
    desc: "Every smile is unique, and so is every treatment. We listen, understand your concerns, and design treatments tailored to your needs, lifestyle, and goals.",
    icon: "🦷",
  },
  {
    title: "Clinical Excellence",
    desc: "Our expert team combines skill, experience, and compassion, using the latest advances in dental science for safe, effective, and minimally invasive care.",
    icon: "🎓",
  },
  {
    title: "Your Safety, Our Priority",
    desc: (
      <>
        Patient safety is non-negotiable. We follow stringent sterilization and infection control protocols:
        <ul>
          <li>All instruments sterilized with class B autoclave systems after every use.</li>
          <li>Disposable items used whenever possible to eliminate cross-contamination risks.</li>
          <li>Treatment areas sanitized before and after every patient.</li>
        </ul>
        Every patient receives care in a hygienic, worry-free setting.
      </>
    ),
    icon: "🧴",
  },
  {
    title: "Every Detail Matters",
    desc: "We source top-grade, internationally approved materials for every filling, crown, veneer, and implant to ensure durability, safety, and natural aesthetics.",
    icon: "💎",
  },
  {
    title: "A Space Designed for Your Comfort",
    desc: "Calm lighting, soothing interiors, and ergonomic dental chairs create a stress-free environment. Our team’s empathy and communication ensure a positive experience.",
    icon: "🌿",
  },
  {
    title: "Digital Dentistry for the Modern Age",
    desc: "State-of-the-art tech—digital X-rays, intraoral scanners, smile design, and laser dentistry—enables precision, comfort, and minimally invasive outcomes.",
    icon: "💻",
  },
  {
    title: "Education and Prevention",
    desc: "We spend time educating patients on oral hygiene and preventive care, so your smile stays healthy beyond the clinic.",
    icon: "📘",
  },
];

const AboutUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 900,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <section id="aboutUsPageId" className="aboutUsSectionPage">
      <div className="container">
        {/* Title Section */}
        <div className="section-titlesa" data-aos="fade-down">
          <h1>About Us</h1>
          <p className="subtitle">
            <strong>Your Path to a Healthy Dental Life</strong>
          </p>
        </div>

        {/* Intro Section */}
        <div className="about-block intro-block" data-aos="fade-up">
          <div className="intro-content">
            <p>
              At <strong>Denvia Dental Clinic</strong>, we believe that a healthy smile is the foundation of a healthy life. Our tagline, <em>“Your Path to a Healthy Dental Life”</em>, reflects our commitment to guiding you toward lasting oral health — through personalized care, advanced treatments, and genuine compassion.
            </p>
            <p>
              We understand that dental care is more than just treating teeth; it’s about helping you build lifelong confidence, comfort, and wellbeing. Our approach goes beyond routine checkups — we focus on education, prevention, and continuous support to help you make informed choices for your smile.
            </p>
          </div>
          <div className="intro-image">
            <img src={aboutImage} alt="Denvia Dental Clinic" className="aboutusImage" />
          </div>
        </div>

        {/* Core Values */}
        <div className="about-block values-block modern-values" data-aos="fade-up">
          <h2 className="section-heading">Our Core Values</h2>
          <p className="section-subtext">
            The foundation of Denvia Dental Clinic — blending care, science, and trust.
          </p>
          <div className="values-grid">
            {coreValues.map((value, index) => (
              <div
                className="value-card-modern"
                data-aos="fade-in"
                data-aos-delay={index * 100}
                key={index}
              >
                <div className="icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <div className="core-value-desc">{value.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Philosophy Section */}
        <div className="about-block philosophy-block modern-philosophy" data-aos="zoom-in">
          <h2>Our Philosophy</h2>
          <blockquote>
            At Denvia Dental Clinic, we see dentistry as more than just a profession — it’s a lifelong partnership with our patients. We strive to make every appointment a positive step on your path to a healthy dental life, empowering you with knowledge, comfort, and confidence along the way.
          </blockquote>
          <p>
            Our ultimate goal is to help you achieve a smile that’s not only beautiful but truly healthy — because a healthy smile leads to a healthier you.
          </p>
        </div>

        {/* Experience Section */}
        <div className="about-block closing-block modern-experience" data-aos="fade-up">
          <h2>Experience the Denvia Difference</h2>
          <p>
            From advanced sterilization and premium materials to compassionate care and a peaceful environment, Denvia Dental Clinic is where modern dentistry meets genuine human connection.
          </p>
          <div className="experience-highlights">
            <div className="highlight" data-aos="fade-up" data-aos-delay="0">
              <span>🌟</span>
              <h4>Advanced Technology</h4>
              <p>From digital scanning to laser treatments, experience cutting-edge care.</p>
            </div>
            <div className="highlight" data-aos="fade-up" data-aos-delay="100">
              <span>🤝</span>
              <h4>Compassionate Team</h4>
              <p>Our clinicians and support staff put your comfort and wellbeing first.</p>
            </div>
            <div className="highlight" data-aos="fade-up" data-aos-delay="200">
              <span>🏥</span>
              <h4>Comfort-First Design</h4>
              <p>Step into a calm, patient-friendly space where every visit feels like home.</p>
            </div>
          </div>
          <p className="closing-invite">
            Come visit us and take your first step on your path to a healthy dental life—where every smile is cared for with precision, passion, and pride.
          </p>
        </div>
      </div>
      {/* What's app bot section */}
            <FloatingWhatsApp
                avatar={clinicIcon}
                notification={false}
                accountName="Denvia Dental Clinic"
                phoneNumber={PHONE_NUMBER}
                onSubmit={(e) => {
                    whatsAppBotListener(e.target[0].value);
                }}
      />
    </section>
  );
};

export default AboutUsPage;
